import axios from 'axios'

const URL = 'https://api.openweathermap.org/data/2.5/weather';
//const API_KEY = 'ef9c032df3c56bb7df421d20f40d880b';
const API_KEY = 'b20081cb14f906c6eb0f9e36e7a75265';
export const fetchWeather = async (query) => {
    const { data } = await axios.get(URL, {
        params: {
            zip: query+",IN",
            units: 'metric',
            APPID: API_KEY,
        }
    });

    return data;
}